<script>
    // modified from https://svelte.dev/repl/d65a4e9f0ae74d1eb1b08d13e428af32?version=3.35.0
    // based on suggestions from:
    // Inclusive Components by Heydon Pickering https://inclusive-components.design/toggle-button/
    // On Designing and Building Toggle Switches by Sara Soueidan https://www.sarasoueidan.com/blog/toggle-switch-design/
    // and this example by Scott O'hara https://codepen.io/scottohara/pen/zLZwNv 


    export let label;
    export let design = 'inner label'
	export let checked = false;
    export let disabled = false;
    export let falseText = 'off';
    export let trueText = 'on';


    const uniqueID = Math.floor(Math.random() * 100)

</script>

{#if design == 'inner'}
    <div class="s s--inner">
        <span class="small-heading" id={`switch-${uniqueID}`}>{label}</span>
        <button
            role="switch"
            aria-checked={checked}
            aria-labelledby={`switch-${uniqueID}`}
            disabled={disabled}
            on:click={() => checked = !checked}>
                <span>{falseText}</span>
                <span>{trueText}</span>
        </button>
    </div>
{/if}

<style>
	:root {
		--accent-color: CornflowerBlue;
		--gray: #ccc;
	}
    .s--inner {
        position: relative;
        display: flex;
        flex-direction: column;
    }
    /* Inner Design Option */
    .s--inner button {
        padding: 2px 2px 3px;
        background-color: #666;
    }
    .s--inner button:disabled {
        opacity: 0.5;
    }

    .s--inner button span {
        user-select: none;
        pointer-events:none;
        padding: 2px;
        line-height: 1;
    }

    .s--inner button:focus {
        outline: var(--accent-color) solid 1px;
    }

    /* gravy */ 

    /* Inner Design Option */
    [role='switch'][aria-checked='false'] :first-child {
        background: #ae2e25;
    }
    [role='switch'][aria-checked='true'] :last-child {
        background: #7fc51f;
    }
    [role='switch'][aria-checked='true'] :first-child,
    [role='switch'][aria-checked='false'] :last-child {
        border-radius: 2px;
        display: inline-block;
        color: #ddd;
    }

    .s--inner button:focus {
        box-shadow: 0 0px 8px var(--accent-color);
        border-radius: 0.1em;
    }

</style>